import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { INDESAP } from '../../theme';

export default function LoadingSpinner({ message = 'Cargando...' }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <CircularProgress sx={{ color: INDESAP.navy }} />
      <Typography variant="body2" color="text.secondary">{message}</Typography>
    </Box>
  );
}
